import { render, staticRenderFns } from "./IframeModal.vue?vue&type=template&id=c58b67c0&scoped=true&"
import script from "./IframeModal.vue?vue&type=script&lang=ts&"
export * from "./IframeModal.vue?vue&type=script&lang=ts&"
import style0 from "./IframeModal.vue?vue&type=style&index=0&id=c58b67c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58b67c0",
  null
  
)

export default component.exports